'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var descriptionKeys = {};

exports.default = function (description) {
  if (descriptionKeys[description]) return descriptionKeys[description];
  var hash = 0;
  if (description.length === 0) return hash;
  description.split('').forEach(function (char) {
    hash = (hash << 5) - hash + char.charCodeAt(0);
    hash = hash & hash;
  });
  var key = 'desc_' + hash.toString().replace('-', 'n');
  descriptionKeys[description] = key;
  return key;
};

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/property-translator/static-1.251/js/internal/getDescriptionHashKey.js
// module id = 485
// module chunks = 0